module.exports = __webpack_public_path__ + "img/italy-diseases-of-the-nervous-system-female.b115eb91.png";